export default "__VITE_ASSET__BAAQT1Pm__"